import React from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import config from '../config.js'

import {fetchDataIfReady, fetchDataIfUndefined, clearStateBlock} from 'Skelet/src/modules/fetch.action.js'
import {handleChange} from 'Skelet/src/modules/functions.js';
import Graph from 'Skelet/src/components/Graph.js'
import Graph24H from 'Skelet/src/components/Graph24H.js'
import GraphHours from 'Skelet/src/components/GraphHours.js'
import GraphWeekdays from 'Skelet/src/components/GraphWeekdays.js'
import GraphCumulative from 'Skelet/src/components/GraphCumulative.js'
import GraphWeeks from 'Skelet/src/components/GraphWeeks.js'
import {time_ago_txt} from 'Skelet/src/modules/time_ago.js'
import refresh_icon from './28406.svg';


class Events extends React.Component {

  constructor(props) {
    super(props);

    this.state = {filtered:false, from_date:""};
  }

  componentWillMount() {
    if(this.props.session_token) {
      this.props.fetchDataIfReady(config.api_token, "item_list", "GET", config.api_url+"/list?t="+this.props.session_token);
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.session_token) {
      let param_from_date = (this.state.from_date !== "") ? "&from_date="+this.state.from_date : "";
      this.props.fetchDataIfUndefined(config.api_token, "item_list", "GET", config.api_url+"/list?t="+nextProps.session_token+param_from_date);
    }
  }

  render() {
    let card = null, cards = [], end_of_list_text = "", refresher_text = "", page_cards = this.props.apiData["item_list"], group_buttons = null, date_filter = null, past7days = null;
    if(page_cards !== undefined) {

      group_buttons = <div className="card">
        <button onClick={() => {this.setFilter("t_twitter")}} style={{marginRight:"10px", marginBottom:"10px", padding:"6px 12px", borderRadius:"10px", border:0, background:"#8bc34a", color:"#fff"}}>t_twitter</button>
        <button onClick={() => {this.setFilter("t_instagram")}} style={{marginRight:"10px", marginBottom:"10px", padding:"6px 12px", borderRadius:"10px", border:0, background:"#ff1657", color:"#fff"}}>t_instagram</button>
        <button onClick={() => {this.setFilter("t_tiktok")}} style={{marginRight:"10px", marginBottom:"10px", padding:"6px 12px", borderRadius:"10px", border:0, background:"#ffd735", color:"#000"}}>t_tiktok</button>
        <button onClick={() => {this.setFilter("t_bitsunlock")}} style={{marginRight:"10px", marginBottom:"10px", padding:"6px 12px", borderRadius:"10px", border:0, background:"#c9ad6c", color:"#222126"}}>t_bitsunlock</button>
        <button onClick={() => {this.setFilter("t_bluesky")}} style={{marginRight:"10px", marginBottom:"10px", padding:"6px 12px", borderRadius:"10px", border:0, background:"#CC1100", color:"#fff"}}>t_bluesky</button>
        <button onClick={() => {this.setFilter("t_simplebsf")}} style={{marginRight:"10px", marginBottom:"10px", padding:"6px 12px", borderRadius:"10px", border:0, background:"#AA0E00", color:"#fff"}}>t_simplebsf</button>
        {/*<button onClick={() => {this.setFilter("t_opc")}} style={{marginRight:"10px", marginBottom:"10px", padding:"6px 12px", borderRadius:"10px", border:0, background:"#40d9ff", color:"#fff"}}>t_opc</button>
        <button onClick={() => {this.setFilter("Dieet.Club")}} style={{marginRight:"10px", marginBottom:"10px", padding:"6px 12px", borderRadius:"10px", border:0, background:"#15a033", color:"#fff"}}>Dieet.Club</button>*/}
        <button onClick={() => {this.setFilter("BountyHub")}} style={{marginRight:"10px", marginBottom:"10px", padding:"6px 12px", borderRadius:"10px", border:0, background:"#7729c6", color:"#fff"}}>BountyHub</button>
        <button onClick={() => {this.setFilter("t_fitnesschallenges")}} style={{marginRight:"10px", marginBottom:"10px", padding:"6px 12px", borderRadius:"10px", border:0, background:"#EB6C29", color:"#fff"}}>t_fitnesschallenges</button>

        <button onClick={() => {this.setFilter(false)}} style={{marginRight:"10px", marginBottom:"10px", padding:"6px 12px", borderRadius:"10px", border:0, background:"#000", color:"#fff"}}>no filter</button>
      </div>;

      date_filter = <div className="card settings">
        <form onSubmit={(e) => {e.preventDefault();this.refresh()}} className="card-layout">
          <div><input type="date" value={this.state.from_date} onChange={(e) => handleChange(this, "from_date", e)} maxLength="10" placeholder="YYYY-MM-DD" /></div>
          <div className="form-actions"><input type="submit" value="ophalen" disabled={page_cards.isFetching} style={{margin:"0 0 0 7px", padding:"1px 12px"}} /></div>
        </form>
      </div>;

      let values = {};
      let p7d = [];
      let d = new Date();
      let today = d.getFullYear()+"-"+(d.getMonth()+1)+"-"+d.getDate();
      let yd1 = new Date(d.getTime()-(86400000)); // 24 hours in milliseconds
      let ystd1 = yd1.getFullYear()+"-"+(yd1.getMonth()+1)+"-"+yd1.getDate();
      let yd2 = new Date(d.getTime()-(86400000*2)); // 24*2 hours in milliseconds
      let ystd2 = yd2.getFullYear()+"-"+(yd2.getMonth()+1)+"-"+yd2.getDate();
      let yd3 = new Date(d.getTime()-(86400000*3)); // 24*3 hours in milliseconds
      let ystd3 = yd3.getFullYear()+"-"+(yd3.getMonth()+1)+"-"+yd3.getDate();
      let yd4 = new Date(d.getTime()-(86400000*4)); // 24*4 hours in milliseconds
      let ystd4 = yd4.getFullYear()+"-"+(yd4.getMonth()+1)+"-"+yd4.getDate();
      let yd5 = new Date(d.getTime()-(86400000*5)); // 24*5 hours in milliseconds
      let ystd5 = yd5.getFullYear()+"-"+(yd5.getMonth()+1)+"-"+yd5.getDate();
      let yd6 = new Date(d.getTime()-(86400000*6)); // 24*6 hours in milliseconds
      let ystd6 = yd6.getFullYear()+"-"+(yd6.getMonth()+1)+"-"+yd6.getDate();
      let yd7 = new Date(d.getTime()-(86400000*7)); // 24*7 hours in milliseconds
      let ystd7 = yd7.getFullYear()+"-"+(yd7.getMonth()+1)+"-"+yd7.getDate();
      for(var p7d_i = 0; p7d_i < page_cards.data.length; p7d_i++) {
        let item = page_cards.data[p7d_i];
        let d = new Date(item.created_on);
        let key = d.getFullYear()+"-"+(d.getMonth()+1)+"-"+d.getDate();
        if(key === today) {
          continue;
        } else if(key === ystd1 || key === ystd2 || key === ystd3 || key === ystd4 || key === ystd5 || key === ystd6 || key === ystd7) {
          if(values[key] === undefined) {
            values[key] = 1;
          } else {
            values[key]++;
          }
        } else {
          break;
        }
      }
      for(let value_key in values) {
        p7d.push(<div key={"2k"+value_key}><small style={{fontSize:"70%", opacity:".6"}}>{value_key}</small> <span style={{fontSize:"110%"}}>+{values[value_key]}</span></div>);
      }
      past7days = <div className="card">{p7d}</div>;

      for(let i = 0; i < page_cards.data.length; i++) {
        if(i > 29) break;
        let item = page_cards.data[i];
        item.time_ago_txt = time_ago_txt(item.created_on);

        cards.push(<div key={"1k"+i} className="contact">
          <div className="contact-name">[{item.app_id}] [{item.label}] {item.ext_id}</div>
          <small style={{opacity:".5", display:"block", fontSize:"75%"}}>{item.time_ago_txt}</small>
          <small style={{opacity:".5", display:"block", fontSize:"75%"}}>{item.country} &middot; {item.created_on}</small>
        </div>);
      }
      card = <div className="card contacts">{cards}</div>;
    }

    if(page_cards === undefined || page_cards.isFetching) {
      end_of_list_text = "Laden..";
      refresher_text = "Laden.. ";
    } else if((page_cards !== undefined && !page_cards.isFetching)) {
      if(page_cards.data[0] !== undefined) {
        end_of_list_text = "Einde van resultaten.";
        refresher_text = "";
      } else {
        end_of_list_text = "Geen events.";
        refresher_text = "";
      }
    }

    return (
      <div className="container content" ref={this.setWrapperRef}>
        <div className="card-layout">
          <div className="card-layout-div50"><strong>Events</strong></div>
          <div className="card-layout-div50 refresher">{refresher_text}<img src={refresh_icon} alt="Vernieuwen" onClick={() => this.refresh()}/></div>
        </div>
        {page_cards !== undefined && group_buttons}
        {page_cards !== undefined && date_filter}
        {/*page_cards !== undefined && <GraphCumulative data={page_cards.data} groups={{"t_twitter":"#8bc34a", "t_instagram":"#ff1657", "t_tiktok":"#ffd735", "t_bitsunlock":"#c9ad6c", "t_bluesky":"#CC1100", "t_opc":"#40d9ff", "Dieet.Club":"#15a033", "BountyHub":"#7729c6", "rest":"#222222"}} filtered={this.state.filtered} />*/}
        {page_cards !== undefined && <GraphWeeks data={page_cards.data} groups={{"t_twitter":"#8bc34a", "t_instagram":"#ff1657", "t_tiktok":"#ffd735", "t_bitsunlock":"#c9ad6c", "t_bluesky":"#CC1100", "t_simplebsf":"#AA0E00", "t_opc":"#40d9ff", "Dieet.Club":"#15a033", "BountyHub":"#7729c6", "t_fitnesschallenges":"#EB6C29", "rest":"#222222"}} filtered={this.state.filtered} />}
        {page_cards !== undefined && <Graph data={page_cards.data} groups={{"t_twitter":"#8bc34a", "t_instagram":"#ff1657", "t_tiktok":"#ffd735", "t_bitsunlock":"#c9ad6c", "t_bluesky":"#CC1100", "t_simplebsf":"#AA0E00", "t_opc":"#40d9ff", "Dieet.Club":"#15a033", "BountyHub":"#7729c6", "t_fitnesschallenges":"#EB6C29", "rest":"#222222"}} filtered={this.state.filtered} />}
        {page_cards !== undefined && <Graph24H data={page_cards.data} filtered={this.state.filtered} />}
        {/*page_cards !== undefined && <GraphHours data={page_cards.data} filtered={this.state.filtered} />*/}
        {/*page_cards !== undefined && <GraphWeekdays data={page_cards.data} filtered={this.state.filtered} />*/}
        {page_cards !== undefined && page_cards.data[0] !== undefined && past7days}
        {page_cards !== undefined && page_cards.data[0] !== undefined && card}
        <div className="end_of_list_text">{end_of_list_text}</div>
      </div>
    );
  }

  refresh() {
    this.props.clearStateBlock("item_list");
  }

  setFilter(new_filter) {
    this.setState({filtered:new_filter});
  }

}


function mapStateToProps(state) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
    apiData: state.apiData,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    fetchDataIfUndefined,
    clearStateBlock,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Events)



// WEBPACK FOOTER //
// ./src/containers/Events.js